import { TFunction } from 'i18next';
import { Objective } from './objectives';

export type Feature =
  | 'TestFeature1'
  | 'TestFeature2'
  | 'Marketing Permission'
  | 'Cart Abandonment'
  | 'Browse Abandonment';

export enum FeatureTypes {
  MPS = 'Marketing Permission',
  CartAbandonment = 'Cart Abandonment',
  cartAbandonment = 'Cart Abandonment',
  BrowseAbandonment = 'Browse Abandonment',
  browseAbandonment = 'Browse Abandonment',
}

const featureFlagMap: { [feat in Feature]?: string } = {
  'Browse Abandonment': 'browse-abandonment-rule',
};

const featureIconMap: { [feat in Feature]?: string } = {
  'Browse Abandonment': 'eye',
  'Cart Abandonment': 'cart-arrow-down',
  'Marketing Permission': 'handshake-alt',
};

/* TODO: the translations should be changed from frequency caps to campaigns */
export const offSiteFeatures = (t: TFunction) => [
  { value: 'BROWSE_ABANDONMENT', label: t('settings.frequencyCaps.capFeatures.options.browseAbandonment') },
  { value: 'CART_ABANDONMENT', label: t('settings.frequencyCaps.capFeatures.options.cartAbandonment') },
];

const description: { [t in Feature]: string } = {
  'Browse Abandonment': 'Send an email to users who have browsed the site without purchasing.',
  'Cart Abandonment': 'Send an email to users who abandon their baskets',
  'Marketing Permission': 'Show a real time message to collect users permissions to receive marketing emails.',
  TestFeature1: 'A mock feature for tests',
  TestFeature2: 'A mock feature for tests',
};

const featureMap: { [o in Objective]: Feature[] } = {
  'Ensure Legislative Compliance': ['Marketing Permission'],
  'Recover Abandoned Sales': ['Cart Abandonment', 'Browse Abandonment'],
  TestObjective: ['TestFeature1', 'TestFeature2'],
};

const getDescription = (feature: Feature): string => description[feature] || '';
const getFeatureFlag = (feature: Feature): string =>
  feature && !!featureFlagMap[feature] ? featureFlagMap[feature] : null;
const getIcon = (feature: Feature): string => featureIconMap[feature] || 'clipboard-check';
const getFeaturesForObjective = (objective: Objective): Feature[] => featureMap[objective] || [];
const isValid = (objective: Objective, type: Feature): boolean => {
  return objective ? featureMap[objective].indexOf(type) > -1 : false;
};

export const Features = {
  getDescription,
  getFeatureFlag,
  getFeaturesForObjective,
  isValid,
  getIcon,
};
